import React from "react";
import styled from "@emotion/styled";

import Section from "@components/Section";
import SEO from "@components/SEO";
import Layout from "@components/Layout";
import Paginator from "@components/Navigation/Navigation.Paginator";

import AuthorHero from "../sections/author/Author.Hero";
import AuthorArticles from "../sections/author/Author.Articles";

import { Template } from "@types";

const ArticlesPage: Template = ({ location, pageContext }) => {
  const author = pageContext.additionalContext.author;
  const articles = pageContext.group;

  return (
    <Layout>
      <SEO
        pathname={location.pathname}
        title={author.name}
        description={author.bio}
      />
      <Section narrow>
        <AuthorHero author={author} />
        {author.name === "Iris Chew" ? (
          <IntroSection>
            <p>我呢，是個從數位行銷轉職到前端的捧油。沒有多厲害，寫程式也沒多有天份，但就是從每一次嘗試中，不斷失敗但也不斷進步。也喜歡那個有在進步的自己～</p>
            <p>希望藉由部落格，紀錄生活，紀錄前端所學，努力成為更好的自己？哈哈哈</p>
          </IntroSection>
        ) : (
          <>
            <AuthorArticles articles={articles} />
            <AuthorPaginator>
              <Paginator {...pageContext} />
            </AuthorPaginator> 
          </>
        )}
      </Section>
      {/* <AuthorsGradient /> */}
    </Layout>
  );
}

export default ArticlesPage;

const AuthorsGradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 590px;
  z-index: 0;
  pointer-events: none;
  background: ${p => p.theme.colors.gradient};
  transition: ${p => p.theme.colorModeTransition};
`;

const AuthorPaginator = styled.div`
  text-align: center;
`;

const IntroSection = styled.div`
  margin: 0 auto;
  max-width: 600px;

  p{
      font-family: ${p => p.theme.fonts.sansSerif};
      line-height: 1.4;
      color: ${p => p.theme.colors.grey};
      margin-bottom: 15px;
      text-align: justify;
  } 
`;
